import { createColumnHelper } from '@tanstack/react-table';

import { StackInAsyncSnapshot } from '../types';

export const columnHelper = createColumnHelper<StackInAsyncSnapshot>();
